let debounceTimeOut: NodeJS.Timeout = null;

export const debounceFunction = (func, wait, immediate = false) => {
  const later = () => {
    debounceTimeOut = null;
    if (!immediate) {
      func();
    }
  };
  const callNow = immediate && !debounceTimeOut;

  clearTimeout(debounceTimeOut);
  debounceTimeOut = setTimeout(later, wait);
  if (callNow) {
    func();
  }
};

const timeouts: Map<string, NodeJS.Timeout> = new Map<string, NodeJS.Timeout>();

export const debounceFunct = (func, wait = 50, label = 'default') => {
  const later = () => {
    clearTimeout(timeouts.get(label));
    timeouts.set(label, null);
    func();
  };

  clearTimeout(timeouts.get(label));
  timeouts.set(label, null);
  timeouts.set(label, setTimeout(later, wait));
};
